<template>
  <div class="all_game">
    <div class="title">
      <router-link :to="{ name: 'Home' }">首页</router-link>
      <router-link :to="{ name: 'AllGame' }"
        >&emsp;<span class="Breadcrumb"
          ><i class="el-icon-arrow-right"></i></span
        >&emsp;全部游戏
      </router-link>
    </div>
    <div class="list">
      <div class="list_item logo">
       <img src="@/assets/image/AllGame/logo.png" alt="" />
        <!-- <img src="@/assets/image/AllGame/xxyn-banner.png" alt="" @click="handleBanner"/> -->
      </div>
      <div class="list_item search">
        <div class="search_tabs">
          <span
            :class="action.gameTypeId === '' ? 'active' : ''"
            @click="getAllGameData"
          >
            全部游戏
          </span>
          <span
            v-for="(item) in gameClass"
            :key="item.id"
            :class="action.gameTypeId === item.id ? 'active' : ''"
            @click="gameClassClick(item)"
          >
            {{ item.class_name }}
          </span>
        </div>
        <div class="search_input">
          <input
            type="text"
            v-model="search_input_text"
            @keyup.enter="searchBtnClick"
            placeholder="请输入关键词进行搜索"
          />
          <div class="search_btn" @click="searchBtnClick">
            <i class="el-icon-search"></i>
          </div>
        </div>
      </div>
      <div class="list_item opiton">
        <div>
          <span
            :class="action.firstChar === item ? 'active_A-Z' : ''"
            v-for="item in alphabet"
            :key="item"
            v-text="item"
            @click="onClickAlphabet(item)"
          ></span>
        </div>
      </div>

      <div class="list_item history" v-if="historyGameList.length > 0">
        <div class="historyTitle">
          <div class="titleText">最近浏览</div>
          <div
            class="clear"
            @mouseenter="clear = true"
            @mouseleave="clear = false"
            @click="clearHistory"
          >
            <i class="el-icon-delete"></i>
            清空最近浏览
          </div>
        </div>
        <ul>
          <router-link
            v-for="item in historyGameList"
            :key="item.game_id"
            :to="
              item.game_id == '26'
                ? {
                    name: 'SelectGame',
                    params: {
                      game_name: item.game_name,
                      game_class: item.game_class,
                      game_id: item.game_id,
                      productTypeSelect: 1,
                    },
                    query: { game_id: item.game_id, game_alias: 'yuanshen5' },
                  }
                : {
                    name: 'SelectGame',
                    params: {
                      game_name: item.game_name,
                      game_class: item.game_class,
                      game_id: item.game_id,
                      productTypeSelect: 1,
                    },
                    query: {
                      game_id: item.game_id,
                      game_alias: 'games',
                      gameAlias: item.game_alias,
                    },
                  }
            "
            @click.native="gamesClick(item, true)"
          >
            <div class="game_img"><img :src="item.game_image" alt="" /></div>
            <div class="game_name">{{ item.game_name }}</div>
          </router-link>
        </ul>
      </div>
      <div class="list_item games">
        <ul>
          <router-link
            v-for="item in gameList"
            :key="item.game_id"
            :to="
              item.game_id == '26'
                ? {
                    name: 'SelectGame',
                    params: {
                      game_name: item.game_name,
                      game_class: item.game_class,
                      game_id: item.game_id,
                      productTypeSelect: 1,
                    },
                    query: { game_id: item.game_id, game_alias: 'yuanshen5' },
                  }
                : {
                    name: 'SelectGame',
                    params: {
                      game_name: item.game_name,
                      game_class: item.game_class,
                      game_id: item.game_id,
                      productTypeSelect: 1,
                    },
                    query: {
                      game_id: item.game_id,
                      game_alias: 'games',
                      gameAlias: item.game_alias,
                    },
                  }
            "
            @click.native="gamesClick(item, false)"
          >
            <div class="game_img"><img :src="item.game_image" alt="" /></div>
            <div class="game_name">{{ item.game_name }}</div>
          </router-link>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import {
  apiGameList,
  apiGameClass,
  apiHistoryList,
  apiHistoryAdd,
  apiHistoryDel,
} from "@/request/API";
import storage from "@/util/storage";

export default {
  name: "allgame",
  props: {},
  components: {},
  data() {
    return {
      //游戏类型 && 首字母
      action: {
        gameTypeId: "",
        firstChar: "全部",
      },
      //A-Z
      alphabet: [],
      //搜索框文本
      search_input_text: "",
      //游戏列表
      gameList: [],
      gameClass: [],
      //最近浏览
      historyGameList: [],
      //清空最近浏览Hover
      clear: false,
    };
  },
  methods: {
    //首字母列表点击事件
    onClickAlphabet(item) {
      this.action.firstChar = item;
      if (item === "全部") {
        item = "";
      }
      this.getGameList("", item, this.action.gameTypeId);
    },
    // 展开全部游戏 获取全部游戏列表
    getAllGameData() {
      this.action = {
        gameTypeId: "",
        firstChar: "全部",
      };
      this.getGameList();
    },
    // 游戏类型点击事件
    gameClassClick(data) {
      this.action = {
        gameTypeId: data.id,
        firstChar: "全部",
      };
      this.getGameList("", "", data.id);
    },
    //搜索按钮点击事件
    searchBtnClick() {
      this.$sensorsTrack.GameSearchClick(this.$route.name)
      this.action = {
        gameTypeId: "",
        firstChar: "全部",
      };
      this.getGameList(this.search_input_text, "", "");
    },
    /**
     * 获取全部游戏列表
     * @param match 搜索框
     * @param game_letter 首字母
     * @param game_class 游戏类别
     */
    getGameList(match, game_letter, game_class) {
      if (game_class === "网络游戏") {
        game_class = "1";
      } else if (game_class === "手机游戏") {
        game_class = "2";
      }
      apiGameList({
        match: match,
        game_letter: game_letter,
        class_id: game_class,
      }).then((res) => {
        this.gameList = res.data;
        if (this.action.firstChar === '全部') {
          this.getHistoryList(res.data)
        }
      });
    },
    /**
     *
     */
    getGameClass() {
      apiGameClass({}).then((res) => {
        this.gameClass = res.data;
      });
    },
    /**
     * 点击游戏
     * @param item 游戏
     */
    gamesClick(item,history) {
      this.$sensorsTrack.BuyGameSelect(item.game_name,item.game_id)
      if (history) {
        if (
          this.gameList.findIndex((items) => items.game_id === item.game_id) >
          -1
        ) {
          item =
            this.gameList[
              this.gameList.findIndex((items) => items.game_id === item.game_id)
            ];
        }
      }
      let ary;
      if (storage.getItem("historyGameList")) {
        ary = JSON.parse(storage.getItem("historyGameList"));
        if (ary.findIndex((items) => items.game_id === item.game_id) === -1) {
          ary.unshift(item);
        } else {
          ary.splice(
            ary.findIndex((items) => items.game_id === item.game_id),
            1
          );
          ary.unshift(item);
        }
        ary = ary.slice(0, 10);
      } else {
        ary = [];
        ary.unshift(item);
      }
      storage.setItem("historyGameList", JSON.stringify(ary));
    },

    /**
     * 清空最近浏览
     */
    clearHistory() {
      this.historyGameList = [];
      storage.setItem("historyGameList", JSON.stringify(this.historyGameList));
    },

    /**
     * 获取最近浏览游戏列表
     */
    getHistoryList(allGame) {
      const allGameIds = allGame.map(item => item.game_id)
      this.historyGameList = JSON.parse(storage.getItem("historyGameList"));
      this.historyGameList.forEach((item, index) => {
        if (item.game_name === '无板块游戏' || !allGameIds.includes(item.game_id)) {
          this.historyGameList.splice(index, 1)
        }
      });
    },

    /**
     * 点击banner
     */
    handleBanner(){
      window.open('https://pxsensorsdata.pxb7.com/t/7a','_blank')
    }
  },
  mounted() {
    //获取首字母列表
    for (var i = 0; i < 26; i++) {
      this.alphabet.push(String.fromCharCode(65 + i));
    }
    this.alphabet.unshift("全部");
    //默认获取全部游戏列表
    this.getAllGameData();
    this.getGameClass();
    this.getHistoryList();
  },
  activated() {
    if (this.$route.params.coupon) {
      apiGameList({
        coupon_id: this.$route.params.coupon_id,
      }).then((res) => {
        this.historyGameList = JSON.parse(storage.getItem("historyGameList")).filter(v=>{
          for(let k of res.data){
            if(k.game_id == v.game_id){
              return v
            }
          }
        })
        setTimeout(() => {
          this.gameList = res.data;
        }, 50);
      });
    }else {
      this.getAllGameData();
      this.historyGameList = JSON.parse(storage.getItem("historyGameList"))
    }
  },
  watch: {},
  computed: {},
  beforeRouteEnter(to,from,next){
    next((vm) => {
      vm.$sensorsTrack.AllGameView(from.name)
    })
  }

}
</script>

<style lang='less' scoped>
.all_game {
  width: 1200px;
  margin: 0 auto 28px;

  .title {
    height: 60px;
    display: flex;
    align-items: center;
    margin-left: 4px;

    a:first-of-type {
      font-size: 14px;
      font-family: PingFangSC-Thin, PingFang SC;
      font-weight: 400;
      color: var(--text-muted, #9AA0AC);
    }

    a:last-of-type {
      font-size: 14px;
      font-family: PingFangSC-Light, PingFang SC;
      font-weight: 600;
      color: var(--text-main, #1A1D24);
    }

    a {
      display: inline-flex;
      align-items: center;
      transition: color 0.2s ease;

      .Breadcrumb {
        display: inline-block;
        width: 7px;
        height: 11px;
        background: var(--border-soft, #E8E4DE);
        transform: skewX(-20deg);

        i {
          display: none;
        }
      }
    }

    a:first-of-type:hover {
      color: var(--primary, #FF5A1F);
    }
  }

  .list {
    background: var(--bg-card, #FFFFFF);
    border: 1px solid var(--border-soft, #E8E4DE);
    border-radius: 4px;
    box-shadow: var(--shadow-card, 0 8px 22px rgba(26, 29, 36, 0.08));
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 24px 20px 10px;

    .list_item {
      width: 1160px;
    }

    .logo {
      height: 119px;
      border-radius: 4px;
      overflow: hidden;
      background: var(--bg-card-soft, #F0EDE8);

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
      }
    }

    .search {
      min-height: 104px;
      background-color: var(--bg-card, #FFFFFF);
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 24px;

      .search_tabs {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        flex: 1;
        gap: 12px;

        span {
          position: relative;
          min-width: 82px;
          height: 36px;
          line-height: 36px;
          margin: 0;
          padding: 0 16px;
          border-radius: 0;
          font-size: 15px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 700;
          text-align: center;
          color: var(--text-secondary, #5A5F6B);
          background: transparent;
          cursor: pointer;
          box-sizing: border-box;
          z-index: 0;
          transition: color 0.2s ease;
        }

        /* 斜切游戏Tab：背景做 skew 平行四边形，文字保持竖直 */
        span::before {
          content: "";
          position: absolute;
          inset: 0;
          background: var(--bg-tag, #F0EDE8);
          transform: skewX(-12deg);
          border-radius: 2px;
          z-index: -1;
          transition: background 0.2s ease;
        }

        span:hover {
          color: var(--text-main, #1A1D24);
        }

        .active {
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 700;
          color: #FFFFFF;
        }

        .active::before {
          background: var(--bg-dark, #1A1D24);
        }

        /* 激活态底部 3px 橙色能量条 */
        .active::after {
          content: "";
          position: absolute;
          inset: 0;
          background: transparent;
          border-bottom: 3px solid var(--primary, #FF5A1F);
          border-radius: 2px;
          transform: skewX(-12deg);
          pointer-events: none;
        }
      }

      .search_input {
        position: relative;
        width: 350px;
        flex: 0 0 350px;

        input {
          width: 100%;
          height: 46px;
          background: var(--bg-card, #FFFFFF);
          border-radius: 3px;
          border: 1.5px solid var(--border-soft, #E8E4DE);
          padding: 0 58px 0 20px;
          font-size: 16px;
          font-family: PingFangSC-Thin, PingFang SC;
          font-weight: 400;
          color: var(--text-main, #111827);
          box-sizing: border-box;
          outline: none;
          transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
        }

        input:focus {
          background: var(--bg-card, #FFFFFF);
          border-color: var(--primary, #FF5A1F);
          box-shadow: none;
        }

        input::-webkit-input-placeholder {
          font-size: 16px;
          font-family: PingFangSC-Thin, PingFang SC;
          font-weight: 400;
          color: var(--text-muted, #9AA0AC);
        }

        .search_btn {
          width: 36px;
          height: 36px;
          position: absolute;
          top: 5px;
          right: 5px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          box-sizing: border-box;
          transition: color 0.2s ease;

          &:hover {
            i {
              color: var(--primary-hover, #E84A12);
            }
          }

          i {
            font-size: 20px;
            font-weight: 600;
            color: var(--primary, #FF5A1F);
          }
        }
      }
    }

    .opiton {
      min-height: 56px;
      background: var(--bg-card, #FFFFFF);
      border: 1px solid var(--border-soft, #E8E4DE);
      border-radius: 4px;
      box-sizing: border-box;

      div {
        min-height: 54px;
        padding: 8px 14px;
        display: flex;
        flex-direction: row;
        align-items: center;
        flex-wrap: wrap;
        gap: 6px;
        box-sizing: border-box;

        span {
          min-width: 34px;
          height: 34px;
          line-height: 34px;
          font-size: 16px;
          font-family: PingFangSC-Light, PingFang SC;
          font-weight: 400;
          padding: 0 8px;
          border-radius: 3px;
          text-align: center;
          color: var(--text-secondary, #5A5F6B);
          cursor: pointer;
          box-sizing: border-box;
          transition: color 0.2s ease, background 0.2s ease;
        }

        span:hover {
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 500;
          color: var(--text-main, #1A1D24);
          background: var(--bg-tag, #F0EDE8);
        }

        .active_A-Z {
          color: #FFFFFF !important;
          background: var(--primary, #FF5A1F);
          font-weight: 500;
        }
      }
    }

    .games,
    .history {
      margin-bottom: 24px;

      ul {
        display: grid;
        grid-template-columns: repeat(10, 1fr);
        align-items: start;
        width: 100%;
        padding-top: 24px;
        gap: 22px 18px;

        li,
        a {
          width: 100%;
          min-width: 0;
          min-height: 116px;
          margin: 0;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: flex-start;
          cursor: pointer;
          border-radius: 4px;
          padding: 12px 8px 10px;
          border: 1px solid transparent;
          box-sizing: border-box;
          transition: background 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;

          .game_img {
            width: 64px;
            height: 64px;
            border-radius: 4px;
            overflow: hidden;
            margin: 0 0 10px;
            background: var(--bg-tag, #F0EDE8);
            box-shadow: 0 6px 14px rgba(26, 29, 36, 0.08);

            img {
              width: 100%;
              height: 100%;
              border-radius: 4px;
              object-fit: cover;
            }
          }

          .game_name {
            width: 100%;
            text-align: center;
            font-size: 16px;
            font-family: PingFangSC-Light, PingFang SC;
            font-weight: 400;
            line-height: 22px;
            color: var(--text-main, #111827);
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }

        a:hover,
        li:hover {
          background: var(--bg-card, #FFFFFF);
          border-color: var(--primary, #FF5A1F);
          box-shadow: 0 8px 22px rgba(26, 29, 36, 0.1);
          transform: translateY(-3px);

          .game_name {
            color: var(--primary, #FF5A1F);
            font-weight: 500;
          }
        }
      }
    }

    .history {
      border-bottom: 1px solid var(--border-soft, #E8E4DE);
      margin-bottom: 0;

      .historyTitle {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;

        .titleText {
          padding: 24px 0 10px;
          font-size: 18px;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          color: var(--text-main, #111827);
        }

        .clear {
          height: 32px;
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 400;
          color: var(--text-muted, #9AA0AC);
          background: transparent;
          border: 1px solid transparent;
          cursor: pointer;
          display: flex;
          align-items: center;
          padding: 0 12px;
          border-radius: 4px;
          transition: color 0.2s ease, background 0.2s ease, border-color 0.2s ease;

          i {
            margin: 0 6px 0 0;
            font-size: 15px;
          }
        }

        .clear:hover {
          color: var(--primary, #FF7A1A);
          background: var(--primary-soft, #FFF3E7);
          border-color: rgba(255, 122, 26, 0.18);
        }
      }

      ul {
        padding: 0;
      }
    }
  }
}
</style>
